import React from "react"
import { Typography } from "antd"

const { Title } = Typography

const Contact: React.FC = () => {
    return (
        <div className="mt-50 mb-100">
            <Title>Contact Us</Title>
            <p>
                Email us at{" "}
                <a href="mailto:support@workclass.co">support@workclass.co</a>
            </p>
        </div>
    )
}

export default Contact
